import { useTranslation } from 'react-i18next';

import { useFetcher } from '@remix-run/react';

import useToast, { type ToastData } from '~/hooks/useToast';

export const useResendSubscriptionChangeEmail = (subscriberId: string, publicationId: string) => {
  const { t } = useTranslation();
  const fetcher = useFetcher<{
    toast?: ToastData;
  }>();

  useToast(fetcher?.data?.toast);

  const onResend = () => {
    const formData = new FormData();
    formData.append('resend_email_success_message', t('toast.success'));
    formData.append('resend_email_error_message', t('errors.default'));
    formData.append('subscriber_id', subscriberId);
    formData.append('publication_id', publicationId);

    fetcher.submit(formData, {
      method: 'post',
      action: '/resend_subscription_change_email',
    });
  };

  return {
    isLoading: fetcher.state === 'submitting',
    onResend,
  };
};
